<template>
  <div>
    <loading v-if="!showContent"></loading>
    <div class="row" v-if="showContent">
      <div class="program-details program-details-plus">
        <div class="col col-md-12"><h1 class="titulo">{{ item.nameLocutor }}</h1></div>

        <div class="col col-md-12 locutorContent">
          <img v-if="item.imageLocutor" :src="item.imageLocutor" class="locutor"/>

          <a v-if="item.site" :href="item.site" target="_blank" class="site-url">{{ item.site }}</a>
          <p class="texto">{{ item.descriptionLocutor }}</p>
          <div class="redes_sociais" v-if="item">
            <a :href="socialnetwork.url" target="_blank" v-if="socialnetwork.url"
               v-for="socialnetwork in item.socialsNetworks">
              <i :class="getIcon(socialnetwork)" aria-hidden="true"></i>
            </a>
          </div>
          <table>
            <tr v-for="(content, key) in days">
              <td>
                {{ content.label }}
              </td>
              <td>
                <div class="row" v-for="program in content.contentDays">
                  <div class="col col-md-6">
                    {{ program.hourInit.substr(0, 5) }} - {{ program.hourFinish.substr(0, 5) }}
                  </div>
                  <div class="col col-md-6">
                    <router-link :to="getUrl(program.idProgram, program.nameProgram)">
                      {{ program.nameProgram }}
                    </router-link>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Programa',
        showContent: false,
        days: [],
        item: {},
        icons: [
          {
            type: 'instagram',
            icon: 'fab fa-instagram'
          },
          {
            type: 'facebook',
            icon: 'fab fa-facebook-f'
          },
          {
            type: 'twitter',
            icon: 'fab fa-twitter'
          },
          {
            type: 'soundCloud',
            icon: 'fab fa-soundcloud'
          },
          {
            type: 'youtube',
            icon: 'fab fa-youtube'
          },
          {
            type: 'google',
            icon: 'fab fa-google-plus-g'
          },
          {
            type: 'whatsapp',
            icon: 'fab fa-whatsapp'
          },
          {
            type: 'blog',
            icon: 'fab fa-rss'
          },
          {
            type: 'myspace',
            icon: 'fab fa-share-alt'
          },
          {
            type: 'flickr',
            icon: 'fab fa-flickr'
          },
          {
            type: 'lastfm',
            icon: 'fab fa-lastfm'
          },
          {
            type: 'viber',
            icon: 'fab fa-share-alt'
          },
          {
            type: 'skype',
            icon: 'fab fa-skype'
          },
          {
            type: 'snapchat',
            icon: 'fab fa-snapchat-ghost'
          }
        ],
        stringDays: [
          {
            value: 'SEG',
            label: 'Segunda',
            order: 1
          },
          {
            value: 'TER',
            label: 'Terça',
            order: 2
          },
          {
            value: 'QUA',
            label: 'Quarta',
            order: 3
          },
          {
            value: 'QUI',
            label: 'Quinta',
            order: 4
          },
          {
            value: 'SEX',
            label: 'Sexta',
            order: 5
          },
          {
            value: 'SAB',
            label: 'Sábado',
            order: 6
          },
          {
            value: 'DOM',
            label: 'Domingo',
            order: 0
          }
        ]
      }
    },
    activated() {
      this.initialize();
    },
    created() {
      // this.initialize();
    },
    methods: {
      initialize() {
        let self = this;
        function compare(a, b) {
          let comparison = 0;
          if (a.order > b.order) {
            comparison = 1;
          } else if (b.order > a.order) {
            comparison = -1;
          }
          return comparison;
        }
        self.showContent = false;
        self.days = [];
        get('locutor-details/' + this.$route.params.id).then(function (response) {
          self.item = response.data.result.data;

          for (let key in response.data.result.data.programs) {
            let currentDay = '';
            self.stringDays.forEach(function (value) {
              // passa uma vez em cada dia
              if (value.value === key) {
                currentDay = value;
              }
            });
            let dayContent = [];
            // foreach nas programacoes do dia, ex array[DOM], no caso, programming tem todos os dias
            response.data.result.data.programs[key].forEach(function (obj) {
              dayContent.push(obj);
            });

            self.days.push({
              value: key,
              label: currentDay.label,
              contentDays: dayContent,
              order: currentDay.order
            });
          }

          self.days.sort(compare);
          self.showContent = true;
        });
      },
      getStringDay(day) {
        let stringDays = [
          {
            value: 'SEG',
            label: 'SEGUNDA'
          },
          {
            value: 'TER',
            label: 'TERÇA'
          },
          {
            value: 'QUA',
            label: 'QUARTA'
          },
          {
            value: 'QUI',
            label: 'QUINTA'
          },
          {
            value: 'SEX',
            label: 'SEXTA'
          },
          {
            value: 'SAB',
            label: 'SÁBADO'
          },
          {
            value: 'DOM',
            label: 'DOMINGO'
          }
        ];
        let stringDay = '';
        stringDays.forEach(function (value) {
          if (value.value === day) {
            stringDay = value.label;
          }
        });
        return stringDay;
      },
      getIcon(item) {
        let currentIcon = '';
        this.icons.forEach(function (value) {
          if (value.type === item.type) {
            currentIcon = value.icon;
          }
        });
        return currentIcon;
      },
      getUrl(id, string) {
        return '/programa/' + id + '/' + slugify(string);
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/LocutorDetails.vue